export const listData = [
    {
        name: 'Farmnote Breedでできること',
        photos: [
            './static/1/1.png',
            './static/1/2.png',
            './static/1/3.png',
            './static/1/4.png',
            './static/1/5.png',
            './static/1/6.png'
        ]
    },
    {
        name: '各リストの見方',
        photos: [
            './static/2/1.png',
            './static/2/2.png',
            './static/2/3.png',
            './static/2/4.png',
            './static/2/5.png',
            './static/2/6.png',
            './static/2/7.png',
            './static/2/8.png',
            './static/2/9.png'
        ]
    },
    {
        name: '牛を追加する',
        photos: [
            './static/3/1.png',
            './static/3/2.png'
        ]
    },
    {
        name: 'Colorセンサーを牛に取り付ける',
        photos: [
            './static/4/1.png',
            './static/4/2.png',
            './static/4/3.png',
            './static/4/4.png',
            './static/4/5.png'
        ]
    },
    {
        name: 'Colorセンサーを牛から取り外す',
        photos: [
            './static/5/1.png',
            './static/5/2.png',
            './static/5/3.png'
        ]
    },
    {
        name: 'Color通知から発情を記録する',
        photos: [
            './static/6/1.png',
            './static/6/2.png',
            './static/6/3.png',
            './static/6/4.png',
            './static/6/5.png'
        ]
    },

    {
        name: '授精予定から授精を記録する',
        photos: [
            './static/7/1.png',
            './static/7/2.png',
            './static/7/3.png',
            './static/7/4.png'
        ]
    },

    {
        name: '未来の授精予定を立てる',
        photos: [
            './static/8/1.png',
            './static/8/2.png',
            './static/8/3.png',
            './static/8/4.png',
            './static/8/5.png'
        ]
    },

    {
        name: '空胎リストでできること',
        photos: [
            './static/9/1.png',
            './static/9/2.png'
        ]
    },

    {
        name: '授精済みリストでできること',
        photos: [
            './static/10/1.png',
            './static/10/2.png',
            './static/10/3.png',
            './static/10/4.png'
        ]
    },

    {
        name: '妊娠中リストでできること',
        photos: [
            './static/11/1.png',
            './static/11/2.png',
            './static/11/3.png'
        ]
    },

    {
        name: '個体情報の見方',
        photos: [
            './static/12/1.png',
            './static/12/2.png',
            './static/12/3.png'
        ]
    },

    {
        name: '牛を繁殖除外にする',
        photos: [
            './static/13/1.png',
            './static/13/2.png'
        ]
    },

    {
        name: '牛を繁殖除外から復帰させる',
        photos: [
            './static/14/1.png',
            './static/14/2.png',
            './static/14/3.png',
            './static/14/4.png'
        ]
    },

    {
        name: '名称・個体識別番号を修正する',
        photos: [
            './static/15/1.png',
            './static/15/2.png'
        ]
    },

    {
        name: '個体を削除する',
        photos: [
            './static/16/1.png'
        ]
    },

    {
        name: '活動量・発情グラフの見方',
        photos: [
            './static/17/1.png',
            './static/17/2.png'
        ]
    },

    {
        name: '活動履歴の確認・巻き戻し',
        photos: [
            './static/18/1.png',
            './static/18/2.png',
            './static/18/3.png',
            './static/18/4.png'
        ]
    },

    {
        name: '牛の表示名の優先順位切り替え',
        photos: [
            './static/19/1.png',
            './static/19/2.png'
        ]
    }
]



// WEBPACK FOOTER //
// ./src/listData.js